import {ITablelistExecute} from '../interfaces';

export class WorklistExecute implements ITablelistExecute {

  public enableCondition: (self) => boolean = (self) => {
    return true;
  }

  protected constructor(public key: string,
                        public label: string,
                        public action: (self) => void,
                        public displayCondition: (self) => boolean = (self) => {
                          return true;
                        }) {

  }

  public static builder(key: string, label: string, action: (self?) => void) {
    return new WorklistExecute(key, label, action);
  }

  public setDisplayCondition(cond: (self) => boolean) {
    this.displayCondition = cond;
    return this;
  }

  public setEnableCondition(cond: (self) => boolean) {
    this.enableCondition = cond;
    return this;
  }
}
